// project imports
import { isMobile } from './Device';

// ===============================|| Plugins ||=============================== //

export const loadCordova = () => {
    if (isMobile) {
        document.addEventListener('deviceready', function () {
            // https://github.com/katzer/cordova-plugin-local-notifications
            cordova.plugins.notification?.local?.setDefaults({
                led: { color: '#0000FF', on: 500, off: 500 },
                vibrate: false
            });

            // https://bitbucket.org/TheBosZ/cordova-plugin-run-in-background
            // https://github.com/buddypunch-nick/cordova-plugin-background-mode.git
            cordova.plugins.backgroundMode?.setDefaults({ silent: true });
            cordova.plugins.backgroundMode?.enable();
            cordova.plugins.backgroundMode?.on('activate', function () {
                cordova.plugins.backgroundMode?.disableWebViewOptimizations();
            });
            cordova.plugins.backgroundMode?.on('deactivate', function () {
                //if (document.getElementsByTagName('form')?.length == 0) location.reload();
            });
            document.addEventListener('backbutton', function (event) {
                const curUrl = window.location.href;
                if (curUrl.indexOf('#') < 0 || curUrl.indexOf('dashboard') >= 0) {
                    //you check that there is nothing left in the history. It will work most of the time in cordova apps but this is not a perfect way to check it
                    cordova.plugins.backgroundMode?.moveToBackground();
                } else {
                    window.history.back();
                }
            });

            // https://github.com/ToniKorin/cordova-plugin-autostart
            cordova.plugins.autoStart?.enable();
            // https://github.com/ionic-team/ionic-plugin-deeplinks
        });
    }

    return true;
};

export default loadCordova;
